"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _coreNumberBadge = _interopRequireDefault(require("@vfuk/core-number-badge"));

var Styled = _interopRequireWildcard(require("./styles/IconGenius.style"));

var _ruleSet = require("../../ruleSet");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconGenius = function IconGenius(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? _ruleSet.nonThemeableRules.defaultSize : _ref$size,
      _ref$isResponsive = _ref.isResponsive,
      isResponsive = _ref$isResponsive === void 0 ? false : _ref$isResponsive,
      _ref$appearance = _ref.appearance,
      appearance = _ref$appearance === void 0 ? 'primary' : _ref$appearance,
      _ref$inverse = _ref.inverse,
      inverse = _ref$inverse === void 0 ? false : _ref$inverse,
      state = _ref.state,
      numberBadge = _ref.numberBadge;
  return /*#__PURE__*/_react["default"].createElement(Styled.IconWrapper, {
    size: size,
    isResponsive: isResponsive,
    appearance: appearance,
    inverse: inverse,
    state: state
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.184 4.793c.714 1.742 1.171 4.332 1.171 7.207 0 5.25-1.5 9.5-3.355 9.5-1.852 0-3.352-4.25-3.352-9.5s1.5-9.5 3.352-9.5c.29.008.57.102.8.273m4.477 16.368.52-.028c.344-.02.668-.16.922-.394 1.308-1.313-.637-5.375-4.348-9.09-3.71-3.715-7.777-5.656-9.09-4.348-1.308 1.313.637 5.38 4.344 9.094 1.969 1.969 4.04 3.441 5.75 4.195l.469.2M12 8.648c5.25 0 9.5 1.5 9.5 3.352 0 1.852-4.25 3.352-9.5 3.352S2.5 13.852 2.5 12c0-1.852 4.25-3.352 9.5-3.352Zm-6.75 7.114.219-.465c.765-1.692 2.222-3.727 4.156-5.672 3.71-3.71 7.777-5.656 9.09-4.348 1.308 1.313-.633 5.383-4.34 9.098-3.707 3.715-7.777 5.656-9.09 4.348a1.523 1.523 0 0 1-.41-1.012l-.016-.527m.18-1.454a.74.74 0 1 1-.742.739c0-.196.078-.383.215-.524a.722.722 0 0 1 .527-.215Zm0 .364a.375.375 0 1 1 0 .75.375.375 0 0 1 0-.75Zm11.512 2.148a.742.742 0 1 1 0 1.485.741.741 0 0 1-.524-1.266.74.74 0 0 1 .524-.219Zm0 .367a.375.375 0 1 1 0 .75.375.375 0 0 1 0-.75ZM13.699 2.906a.742.742 0 1 1 0 1.484.742.742 0 0 1 0-1.484Zm0 .367a.375.375 0 1 1 0 .75.375.375 0 0 1 0-.75Zm-.898-.5.426.305m.957 1.715-.196-.465",
    fill: "none",
    vectorEffect: "non-scaling-stroke"
  })), numberBadge ? /*#__PURE__*/_react["default"].createElement(Styled.NumberBadgeContainer, null, /*#__PURE__*/_react["default"].createElement(_coreNumberBadge["default"], {
    number: numberBadge,
    appearance: inverse ? appearance : 'primary'
  })) : null);
};

IconGenius.displayName = "IconGenius";
var _default = IconGenius;
exports["default"] = _default;
//# sourceMappingURL=IconGenius.js.map